export default {
  categoryList: state => state.category,
  categoryValue: state => state.categoryValue,
  loading: state => state.loading,
  search: state => state.search,
  usersList: state => state.usersList,
  products: state => state.products,
  cart: state => state.cart,
  user: state => state.user,
  vendorsList: state => state.vendorsList,
  error: state => state.error,
  hasUser: state => state.user !== null,
  cartHasProducts: state => state.cart.length > 0
};
